import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { PhoneViewModel } from '../../../models/Entities/Person/Phone/PhoneModels';

// store
import * as PersonPhonesStore from '../../../redux/middleware/PersonPhones.Middleware';

export interface IProps {
  PersonId: number;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  phones: PhoneViewModel[];
}

interface DispatchProps {
  GetPhonesByPersonId: typeof PersonPhonesStore.actionCreators.GetPhonesByPersonId;
  DeletePhone: typeof PersonPhonesStore.actionCreators.DeletePhone;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonPhones?.isLoadingAll,
  isLoadingSuccessfully: state.PersonPhones?.successLoadingAll,
  failOnLoading: state.PersonPhones?.failOnLoadingAll,
  isDeleting: state.PersonPhones?.isDeletingOne,
  failOnDeleting: state.PersonPhones?.failOnDeletingOne,
  error: state.PersonPhones?.error,
  phones: (state.PersonPhones?.list ?? []).filter(
    (item: PhoneViewModel) => item.personId === ownProps.PersonId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonPhonesStore.actionCreators
};
